// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "selectedFare-2aDz_";
var _4 = "compareFares-1lTyF";
var _5 = "groupTitle-3F7P4";
var _6 = "fareHeadingItem__title-17DBf";
var _7 = "fareHeadingItem_isKey-HtPNi";
var _8 = "tableRow-2kD-m";
var _9 = "slider_withoutImages-X9350";
var _a = "fareHeadingItem-24k26";
export { _1 as "__esModule", _2 as "mobile", _3 as "selectedFare", _4 as "compareFares", _5 as "groupTitle", _6 as "fareHeadingItem__title", _7 as "fareHeadingItem_isKey", _8 as "tableRow", _9 as "slider_withoutImages", _a as "fareHeadingItem" }
export default { "__esModule": _1, "mobile": _2, "selectedFare": _3, "compareFares": _4, "groupTitle": _5, "fareHeadingItem__title": _6, "fareHeadingItem_isKey": _7, "tableRow": _8, "slider_withoutImages": _9, "fareHeadingItem": _a }
